import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CursorTab, ProgramsTab } from './utilities'

export default function UtilitiesPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<'programs' | 'cursor'>('programs')

  useEffect(() => {
    const hash = location.hash.replace('#', '')
    if (hash === 'programs') {
      setActiveTab('programs')
    } else if (hash === 'cursor') {
      setActiveTab('cursor')
    } else {
      setActiveTab('programs')
    }
  }, [location.hash])

  const handleTabChange = (tab: 'programs' | 'cursor') => {
    setActiveTab(tab)
    navigate(`#${tab}`)
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Page Title */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Tiện ích & Phần mềm</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-100">Các công cụ và phần mềm hỗ trợ được chia sẻ miễn phí</p>
      </div>

      {/* Tabs */}
      <div className="flex justify-center mb-8">
        <div className="bg-gray-100 dark:bg-gray-900 p-1 rounded-lg inline-flex">
          <button
            onClick={() => handleTabChange('programs')}
            className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
              activeTab === 'programs'
                ? 'bg-white dark:bg-gray-800 text-amber-600 dark:text-blue-300 shadow-sm'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-100'
            }`}
          >
            Chương trình
          </button>
          <button
            onClick={() => handleTabChange('cursor')}
            className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
              activeTab === 'cursor'
                ? 'bg-white dark:bg-gray-800 text-amber-600 dark:text-blue-300 shadow-sm'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-100'
            }`}
          >
            Cursor
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="min-h-[400px]">
        {activeTab === 'programs' ? (
          <ProgramsTab />
        ) : (
          <CursorTab />
        )}
      </div>
    </div>
  )
}
